import { render, staticRenderFns } from "./BSGlyphButton.vue?vue&type=template&id=58113f55&scoped=true"
import script from "./BSGlyphButton.vue?vue&type=script&lang=js"
export * from "./BSGlyphButton.vue?vue&type=script&lang=js"
import style0 from "./BSGlyphButton.vue?vue&type=style&index=0&id=58113f55&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58113f55",
  null
  
)

export default component.exports